import React, { useEffect, useState, useMemo } from "react";
import { useAtedimento } from "../../../../Context/Atendimento";
import { useUserInfor } from "../../../../Context/User";

import WhatsappAtivo, {
    InforWhatsappSend,
} from "./../../../../Components/Utils/WhatsappAtivo/index";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

import {
    DataSnapshot,
    get,
    off,
    onChildAdded,
    onChildChanged,
    onValue,
} from "firebase/database";
import {
    fullFormatPhone,
    formatMessageTimeStamp,
} from "../../../../Tools/FormatTools";

import {
    IChat,
    IMensagem,
} from "../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { Notificate } from "../../../../Tools/Notification";
import {
    getChatsRef,
    getConversaRef,
} from "../../../../Services/Config/ConfigFirebase";
import { useTransformToRef } from "../../../../hooks/useTransformToRef";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import ModalComponent from "./../../../../Components/Modais/index";

interface IChatsProps {
    onChatsUpdate: (lstChats: Array<IChat>) => void;
}

export default function Chats(props: IChatsProps) {
    const {
        FL_MODO_HELP_DESK,
        iniciarAtendimentoHelpDesk,
        finalizarAtendimentoHelpDesk,
        setChatAberto,
        chatAberto,
        equipe,
    } = useAtedimento().HELP_DESK;
    const { OrgInfor, UserInfor } = useUserInfor();

    const [salas, setSalas] = useState<Array<IChat>>([]);
    const [aguardando, setAguardando] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [Modal, setModal] = useState<IComponentModal>({} as IComponentModal);
    // eslint-disable-next-line
    const [mensagens, setMensagens] = useState<Array<IMensagem>>([]);

    const salasOrdered = useMemo(() => {
        return Array.from(salas).sort((a, b) => {
            return b.TimeStamp - a.TimeStamp;
        });
    }, [salas]);

    const onChatsUpdateRef = useTransformToRef(props.onChatsUpdate);

    useEffect(() => {
        if (equipe?.NR_TELEFONE) {
            const salasRef = getChatsRef(
                OrgInfor.ID_ORGANIZACAO,
                equipe.NR_TELEFONE
            );
            off(salasRef, "value"); // garante que o listener de value em salasRef a seguir será o único
            onValue(salasRef, (snap) => {
                const salasArray: Array<IChat> = [];
                let aguardando = 0;
                let chatExists = false;
                snap.forEach((childSnap) => {
                    const sala: IChat = childSnap.val();
                    if (sala.IdUsuario === UserInfor.ID_USUARIO) {
                        salasArray.push(sala);
                        chatExists =
                            chatExists ||
                            (!!chatAberto &&
                                chatAberto.NumeroCliente ===
                                    sala.NumeroCliente);
                    } else if (
                        (sala.IDEquipe === equipe.ID_EQUIPE_HELP_DESK &&
                            sala.IdUsuario === 0) ||
                        (sala.IDEquipe === 0 && equipe.FL_DISTRIBUICAO)
                    )
                        aguardando++;
                });
                if (!chatExists) setChatAberto();
                setSalas(salasArray);
                setAguardando(aguardando);
                onChatsUpdateRef.current(salasArray);
            });
        }
    }, [
        OrgInfor.ID_ORGANIZACAO,
        UserInfor.ID_USUARIO,
        equipe?.NR_TELEFONE,
        equipe.FL_DISTRIBUICAO,
        equipe.ID_EQUIPE_HELP_DESK,
        setChatAberto,
        chatAberto,
        onChatsUpdateRef,
    ]);

    useEffect(() => {
        if (equipe?.NR_TELEFONE) {
            const salasRef = getChatsRef(
                OrgInfor.ID_ORGANIZACAO,
                equipe.NR_TELEFONE
            );
            onChildChanged(salasRef, async (snap) => {
                const chatChanged: IChat = snap.val();
                const conversaRef = getConversaRef(
                    OrgInfor.ID_ORGANIZACAO,
                    equipe.NR_TELEFONE,
                    chatChanged.NumeroCliente
                );

                if (
                    chatChanged.IdUsuario === UserInfor.ID_USUARIO &&
                    (chatChanged.MensagemCliente ||
                        (await get(conversaRef).then(getLastMessageUserId)) !==
                            UserInfor.ID_USUARIO)
                )
                    Notificate(
                        "Mensagem recebida!",
                        `${fullFormatPhone(chatChanged.NumeroCliente)}`
                    );

                function getLastMessageUserId(getSnap: DataSnapshot) {
                    // converte o retorno do firebase em um vetor com key e valor, pega a última mensagem e retorna
                    return getSnap.exists()
                        ? Object.entries<IMensagem>(getSnap.val()).pop()?.[1]
                              .IdUsuario || 0
                        : 0;
                }
            });
            get(salasRef).then((getSnap) => {
                const chatsIniciais: Array<IChat> = [];
                getSnap.forEach((childSnap) => {
                    chatsIniciais.push(childSnap.val());
                });
                onChildAdded(salasRef, (snap) => {
                    const newChat: IChat = snap.val();
                    if (
                        newChat.IdUsuario === UserInfor.ID_USUARIO &&
                        !chatsIniciais.find(
                            (chatInicial) =>
                                chatInicial.NumeroCliente ===
                                newChat.NumeroCliente
                        )
                    )
                        Notificate(
                            "Novo Atendimento!",
                            `${fullFormatPhone(newChat.NumeroCliente)}`
                        );
                });
            });
        }

        return function cleanup() {
            if (equipe?.NR_TELEFONE) {
                off(
                    getChatsRef(OrgInfor.ID_ORGANIZACAO, equipe.NR_TELEFONE),
                    "child_added"
                );
                off(
                    getChatsRef(OrgInfor.ID_ORGANIZACAO, equipe.NR_TELEFONE),
                    "child_changed"
                );
            }
        };
    }, [OrgInfor.ID_ORGANIZACAO, UserInfor.ID_USUARIO, equipe?.NR_TELEFONE]);

    useEffect(() => {
        salas.forEach((sala) => {
            if (
                OrgInfor.ID_ORGANIZACAO &&
                sala.NumeroAtendente &&
                sala.NumeroCliente
            ) {
                const mensagensRef = getConversaRef(
                    OrgInfor.ID_ORGANIZACAO,
                    sala.NumeroAtendente,
                    sala.NumeroCliente
                );

                onValue(mensagensRef, (snap) => {
                    const mensagensArray: Array<IMensagem> = [];

                    snap.forEach((childSnap) => {
                        mensagensArray.push(childSnap.val());
                    });
                    setMensagens((prevMensagens) => {
                        const mensagensNaoDuplicadas = mensagensArray.filter(
                            (mensagem) => {
                                return !prevMensagens.some(
                                    (prevMensagem) =>
                                        prevMensagem.MessageSid ===
                                        mensagem.MessageSid
                                );
                            }
                        );

                        return prevMensagens.concat(mensagensNaoDuplicadas);
                    });
                });
            }
        });
    }, [OrgInfor.ID_ORGANIZACAO, salas]);

    return (
        <div className="card card-custom controlledHeightDiv">
            <h6 className="card-header align-items-center justify-content-center">
                {aguardando} Clientes Aguardando{" "}
                {UserInfor.FUNCOES.some(
                    (f) => f.NM_FUNCAO === "WHATS_MENSAGEM_ATIVA"
                ) && (
                    <span className="m-2">
                        <WhatsappAtivo
                            onClick={() => {
                                setShowModal(true);
                                setModal({
                                    headerComponent: "Enviar mensagem!",
                                    IconHeader: faWhatsapp,
                                    size: "lg",
                                    Component: () => (
                                        <InforWhatsappSend
                                            lstContatos={[]}
                                            setModal={setShowModal}
                                        />
                                    ),
                                });
                            }}
                        />
                    </span>
                )}
            </h6>

            <div className="card-body chats p-0">
                <div className="customScroll">
                    {salasOrdered.map((sala) => {
                        // const validaMensagens = mensagens.filter(
                        //     (mensagem) =>
                        //         mensagem.FL_MsgAntiga === false &&
                        //         mensagem.MensagemCliente === true
                        //);

                        // const validaNumeroCliente = validaMensagens.some(
                        //     (mensagem) => mensagem.From === sala.NumeroCliente
                        // );

                        //if (validaNumeroCliente) {
                        const mimeType = sala.MediaContentType
                            ? sala.MediaContentType.split("/")[0]
                            : undefined;

                        return (
                            <div
                                key={sala.NumeroCliente}
                                className={`d-flex align-items-center chat ${
                                    chatAberto?.NumeroCliente ===
                                    sala.NumeroCliente
                                        ? "selected"
                                        : ""
                                }`}
                                style={{ overflow: "hidden" }}
                                onClick={() => {
                                    setChatAberto(sala);
                                }}
                            >
                                <div className="position-relative">
                                    <div className="symbol symbol-circle symbol-50 mr-3 bg-secondary p-4">
                                        <FontAwesomeIcon
                                            icon={faUser}
                                            size="lg"
                                        />
                                    </div>
                                    {Boolean(sala.Lido) && (
                                        <span
                                            style={{
                                                bottom: 0,
                                                right: 0,
                                            }}
                                            className="label label-warning mr-2 position-absolute"
                                        >
                                            {sala.Lido > 9
                                                ? "+9"
                                                : sala.Lido}
                                        </span>
                                    )}
                                </div>

                                <div className="w-100">
                                    <div className="d-flex flex-column">
                                        <div className="d-flex justify-content-between">
                                            <a
                                                href="#/"
                                                className="text-dark-75 text-hover-primary font-weight-bold font-size-lg"
                                            >
                                                {sala.NomeContatoCliente ||
                                                    fullFormatPhone(
                                                        sala.NumeroCliente
                                                    )}
                                            </a>
                                            <span className="text-muted text-break font-weight-bold font-size-sm">
                                                {formatMessageTimeStamp(
                                                    sala.TimeStamp
                                                )}
                                            </span>
                                        </div>
                                        <span className="text-muted font-weight-bold font-size-sm lastMessage">
                                            {sala.UltimaMensagem
                                                ? sala.UltimaMensagem
                                                : mimeType === "image"
                                                ? "Foto"
                                                : mimeType === "audio"
                                                ? "Audio"
                                                : mimeType === "video" &&
                                                    "Video"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                        //}
                        //return null;
                    })}
                </div>
            </div>

            <div className="card-footer">
                {FL_MODO_HELP_DESK ? (
                    <button
                        className="btn btn-danger"
                        onClick={() => {
                            finalizarAtendimentoHelpDesk();
                        }}
                    >
                        Sair do Atendimento
                    </button>
                ) : (
                    <button
                        className="btn btn-success"
                        onClick={() => {
                            iniciarAtendimentoHelpDesk();
                        }}
                    >
                        Iniciar Atendimento
                    </button>
                )}
            </div>
            <ModalComponent
                show={showModal}
                setShow={setShowModal}
                ModalComponent={Modal}
            />
        </div>
    );
}
